<script setup>
import {ToastClose, ToastDescription, ToastProvider, ToastRoot, ToastTitle, ToastViewport} from "reka-ui";

const { toastState } = useToast()

// const toast.description = computed(() => toast.description)

</script>

<template>
  <ToastProvider>

    <ToastRoot v-model:open="toast.open" v-for="(toast, index) in toastState" :key="index" :duration="toast.duration" class="toast-root relative flex items-center gap-x-4 bg-white shadow-xl px-5 py-4 group rounded-lg">

      <div
          :class="
          [
              toast.description ? 'size-13' : 'size-12',
             {
               'bg-brand/10' : toast.type === 'success',
                'bg-yellow-90/10' : toast.type === 'warning',
                 'bg-red-90/10' : toast.type === 'error'
             }
          ]"
          class="flex items-center justify-center shrink-0 rounded-full">
        <Icon name="bold:tick-circle" :class="[ toast.description ? 'size-7' : 'size-6', {'text-brand' : toast.type === 'success'} ]" v-if="toast.type === 'success'"/>
        <Icon name="bold:info-circle" :class="[ toast.description ? 'size-7' : 'size-6', {'text-yellow-90' : toast.type === 'warning'} ]" v-if="toast.type === 'warning'"/>
        <Icon name="bold:close-circle" :class="[ toast.description ? 'size-7' : 'size-6', {'text-red-90' : toast.type === 'error'} ]" v-if="toast.type === 'error'"/>
      </div>
      <div class="space-y-1">
        <ToastTitle class="text-caption" :class="[ toast.description ? 'font-demibold' : '' ]">{{ toast.title }}</ToastTitle>
        <ToastDescription class="text-label text-secondary" v-if="toast.description">{{ toast.description }}</ToastDescription>
      </div>
      <ToastClose class="size-5 absolute left-5 top-4">
        <button class="size-5 items-center justify-center cursor-pointer opacity-0 group-hover:opacity-100 transition-all">
          <Icon name="linear:close" class="size-5 text-muted"/>
        </button>
      </ToastClose>
    </ToastRoot>
    <ToastViewport class="toast-viewport fixed top-10 sm:top-12 left-0 sm:left-12 max-sm:right-0 mx-auto flex flex-col gap-5 px-5 max-w-100 w-full z-80 outline-none"/>
  </ToastProvider>
</template>

<style>


.toast-root {
  animation: toast-in 250ms ease;
  transform-origin: center top;
}

.toast-root[data-state="closed"] {
  animation: toast-out 100ms ease-in-out forwards;
}

.toast-root[data-swipe="move"] {
  transform: translateX(var(--reka-toast-swipe-move-x));
}

.toast-root[data-swipe="cancel"] {
  transform: translateX(0);
  transition: all 160ms ease-out;
}

.toast-root[data-swipe="end"] {
  animation: swipe-out 150ms ease-out forwards;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: translateX(-80px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes toast-out {
  0% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateX(-80px) scale(0.96);
  }
}

@keyframes swipe-out {
  0% {
    transform: translateX(var(--reka-toast-swipe-end-x));
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
}

.toast-viewport {
  transition: all 0.2s ease;
}
</style>